import { StrapiRelation, StrapiRelations } from '@dh/types';

// Original functions - use documentId when available (for API calls)
export const makeStrapiRelation = <T extends { id: string | number } | { documentId: string }>(
    data?: T
): StrapiRelation => {
    return {
        set: data ? ['documentId' in data ? data.documentId : data.id.toString()] : undefined
    };
};

export const makeStrapiRelations = <T extends { id: string | number } | { documentId: string }>(
    data?: T[]
): StrapiRelations => {
    return {
        set: data
            ? data.map((item) => ('documentId' in item ? item.documentId : item.id.toString()))
            : []
    };
};

// New functions - always use numeric id (for database relations)
// Use these for operations like user registration where Strapi expects numeric IDs
export const makeStrapiRelationById = <T extends { id: string | number }>(
    data?: T
): StrapiRelation => {
    return {
        set: data ? [data.id.toString()] : undefined
    };
};

export const makeStrapiRelationsById = <T extends { id: string | number }>(
    data?: T[]
): StrapiRelations => {
    return {
        set: data ? data.map((item) => item.id.toString()) : []
    };
};

export const makeStrapiConnection = <T extends { id: string | number }>(
    data?: T
): StrapiRelation => {
    return { connect: data ? [data.id.toString()] : undefined };
};

export const makeStrapiConnections = <T extends { id: string | number }>(
    data?: T[]
): StrapiRelations => {
    return { connect: data ? data.map(({ id }) => id.toString()) : [] };
};

// Alias for clarity - same as makeStrapiConnection but explicit about using numeric id
export const makeStrapiConnectionById = makeStrapiConnection;
export const makeStrapiConnectionsById = makeStrapiConnections;
